import GlobalTokens from '@sainsburys-tech/design-tokens/dist/global/json/tokens.json';
import ColourBlock from '@components/colour-block';
import { TableContainer, TableHeader, TableHeaderRow, TableHeaderCell, TableBody, TableRow, TableCell } from '@sainsburys-tech/luna-table';
import { TypographyTableHeader, SainsburysTypographyTableBody, ArgosTypographyTableBody, HabitatTypographyTableBody, TuTypographyTableBody, NectarTypographyTableBody } from '@shared/tables/typography';
import HeadingDisplayTable from '@shared/tables/heading-display';
import { Tick, Cancel } from '@sainsburys-tech/luna-icons';
import * as React from 'react';
export default {
  GlobalTokens,
  ColourBlock,
  TableContainer,
  TableHeader,
  TableHeaderRow,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  TypographyTableHeader,
  SainsburysTypographyTableBody,
  ArgosTypographyTableBody,
  HabitatTypographyTableBody,
  TuTypographyTableBody,
  NectarTypographyTableBody,
  HeadingDisplayTable,
  Tick,
  Cancel,
  React
};